"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { MovieStatusMessage } from "@/components/movies/MovieStatusMessage";
import { getLanguageFromPathname } from "@/lib/i18n/paths";
import { createTranslator } from "@/lib/i18n/translations";
import { logError } from "@/lib/logger";

export default function MovieError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  const pathname = usePathname();
  const lang = getLanguageFromPathname(pathname);
  const t = createTranslator(lang);

  useEffect(() => {
    logError("Movie detail page error", error, {
      component: "MovieDetailErrorBoundary",
      digest: error.digest,
      page: pathname,
    });
  }, [error, pathname]);

  return (
    <MovieStatusMessage
      action={{ label: t("movieDetail.tryAgain"), onPress: retry }}
      description={t("movieDetail.errorDescription")}
      icon="⚠️"
      link={{ href: `/${lang}/movies`, label: t("movieDetail.backToMovies") }}
      title={t("movieDetail.errorTitle")}
    />
  );
}
